<template>
	<div class="login-page-container flex">
		<!-- Left -->
		<div class="left flex xs-middle xs-12 lg-4 xs-center bg1">
			<!-- Login -->
			<div class="flex wrap max5 pl2 pr2 xs-center">
				<!-- Headline -->
				<h2 class="xs-12 ta1 s9 lh125 fs9 c5 mb3">{{ $t("login.log_in") }}</h2>
				<p class="xs-12 ta1 fs4 c7 mb12">
					{{ $t("log_in_by_entering_your_information_below") }}
				</p>

				<!-- Form -->
				<form class="flex wrap xs-12" @submit.prevent="onSubmit">
					<!--  Email Field -->
					<div class="xs-12 mb6">
						<label class="c5">{{ $t("login.email") }}</label>
						<j-base-input-text
							id="username"
							name="email"
							class="mt2"
							autocomplete="username email"
							v-model="username"
							:status="errors.first('email') ? 'error' : null"
							v-validate="{ required: true, email: true }"
						>
							<!-- Email icon -->
							<crm-icon slot="icon" name="email" color="c6" />
						</j-base-input-text>
						<j-text class="fs3 lh125 mt1 cError">
							{{ errors.first("email") }}
						</j-text>
					</div>

					<!-- Password -->
					<div class="xs-12 mb8">
						<label class="c5">{{ $t("login.password") }}</label>
						<j-base-input-password
							type="password"
							id="password"
							class="mt2"
							name="password"
							:status="errors.first('password') ? 'error' : null"
							autocomplete="current-password"
							v-model="password"
							v-validate="{ required: true }"
						>
							<!-- Password icon -->
							<crm-icon slot="icon" name="password" color="c6" />
						</j-base-input-password>
						<j-text class="fs3 lh125 mt1 cError">
							{{ errors.first("password") }}
						</j-text>
					</div>

					<!-- Button -->
					<div class="flex xs-12 xs-center mb12">
						<j-button
							action="login"
							:isLoading="isLoading"
							size="large"
							isFullWidth
							>{{ $t("login.log_in") }}</j-button
						>
					</div>
				</form>

				<hr class="xs-12 c7" />

				<!-- Forgot password / Reset password -->
				<div class="ta2 mt6">
					<router-link
						:to="`/${$route.params.tenantId}/reset-password`"
						class="c7"
						>{{ $t("login.forgot_your_password") }}</router-link
					>
				</div>
			</div>
		</div>

		<!-- Right -->
		<div class="right flex lg-offset2 wrap bg5 xs-middle">
			<!-- Title and Subtitle -->
			<div class="flex wrap xs-12 xs-center">
				<h1 class="xs-12 ta2 fs9 c1 mb2">Welcome to CoverAdmin</h1>
				<p class="xs-12 ta2 c6 fs5 mb10">Enterprise Policy Admin Solution</p>
				<img class="xs-center mb8" :src="loginImage" alt />
				<p class="xs-12 ta2 c2 fs5">Powered by CoverGo</p>
			</div>
		</div>
	</div>
</template>

<script>
import JCard from "@/components/JCard/"
import JHeadline from "@/components/JHeadline/"
import JBaseInputText from "@/components/JBaseInputText/"
import JBaseInputPassword from "@/components/JBaseInputPassword/"
import JButton from "@/components/JButton/"
import JText from "@/components/JText/"
import CrmIcon from "@/components/CrmIcon/"

export default {
	components: {
		JCard,
		JHeadline,
		JBaseInputText,
		JBaseInputPassword,
		JButton,
		JText,
		CrmIcon
	},

	data() {
		return {
			isLoading: false,
			username: null,
			password: null,
			loginImage: require("@/assets/img/login-image.svg")
		}
	},

	methods: {
		async onSubmit() {
			this.isLoading = true

			await this.$validator.validate().then(isValid => {
				if (isValid) {
					this.$store
						.dispatch("auth/logIn", {
							username: this.username,
							password: this.password
						})
						.then(res => {
							// Get previous path that was entered while user was logged in
							// If exists, go to previous path after log in
							// Else go to Dashboard
							const previousPath = window.PATH
							if (previousPath) {
								this.$router.push(previousPath)
							} else
								this.$router.push({
									name: "DashboardHome"
								})

							this.isLoading = false
						})
				} else this.isLoading = false
			})
		}
	},

	mounted() {
		// If there is loggedout argument in URL, show logged out message to user
		if (this.$route.query.loggedout && this.$route.query.loggedout === "true")
			this.$store.dispatch(
				"addMessage",
				{
					message: {
						type: "error",
						text: this.$t("errors.you_have_been_logged_out")
					}
				},
				{ root: true }
			)
	}
}
</script>

<style scoped>
.login-page-container {
	width: 100%;
	height: 100vh;
}
.left {
	width: 100%;
	height: 100vh;
	position: fixed;
	left: 0;
}
.right {
	width: 100%;
	height: 100vh;
}
/* FIXME: Media query problem */
/* @media (--lg) {
		.left {
			width: 500px;
		}
		.right {
			display: flex;
			width: 100%;
			height: 100vh;
			margin-left: 500px;
		}
	} */
</style>
